
import {Component,Mixins} from 'vue-property-decorator'
import EventBus from '../../eventBus'
import { required } from 'vuelidate/lib/validators'
import { Validations } from 'vuelidate-property-decorators'
import UserProVisioning from "@/mixins/userProvisioning"


@Component
export default class BudgetingTemplate extends Mixins(UserProVisioning) {
    selectedRows: {name: string; id: string}[] = []
    selectAll: boolean = false

    @Validations()
    validations = {
        activeTemplate: {
            templateName: {required},
            departmentId: {required}
        }
    }
    private activeScreen: string = 'loading'
    private error: string = '';
    private additionalSuccessMessage: string = '';
    private successMessage: string = '';
    private loadingMessage: string = '';
    private loadingTitle: string = '';
    private activeView: string = 'templates'
    private showForm: boolean = false;
    private isUpdate: boolean = false;
    private search: string = '';
    private deletePromptProperty: boolean = false
    moreInfo= false
    private activeTemplate: any = {
        id: '',
        templateName: '',
        departmentId: '',
        sections: []
    };
    get fields(){
        if(this.canWriteBudgetSettings){
            return [
                     { key: 'selectRow', label: 'Select', sortable: false, thStyle: { width: "60px" }},
                     { key: 'serial', label: 'S/N', sortable: false },
                     { key: 'templateName', label: 'Name'},
                     { key: 'departmentId', label: 'Dept.'},
                     { key: 'budgetLineItems', label: 'Info'},
                     { key: 'button', label: 'Actions'},
                    ];
                    }
        return  [
                { key: 'selectRow', label: 'Select', sortable: false, thStyle: { width: "60px" }},
                { key: 'serial', label: 'S/N', sortable: false },
                { key: 'templateName', label: 'Name'},
                { key: 'departmentId', label: 'Dept.'},
                { key: 'budgetLineItems', label: 'Info'},
                ];
    }
    private budgetLineFields: any[] = [
        { key: 'lineItem', label: 'Name'},
        { key: 'numberOfDependentTemplates', label: 'No of Dependent Template'},
        { key: 'buttons', label: 'Actions'},
    ];
    formErrors: string[] = []

    get isButtonDisabled ():boolean {
        if(this.formErrors.length > 0) {
            return true
        } else {
            return false
        }
    }
    get checkDept (): boolean {
        if (this.activeTemplate.sections.length === 0) {
            return false
        } else if (this.activeTemplate.sections[0].sectionName === ''){
            return false
        } else if (this.activeTemplate.sections[0].budgetLineItems.length === 0){
            return false
        } else {
            return true
        }
    }
    get allProjects() {
        return this.$store.getters['projectModule/getAllProjects']
    }

    disableDelete(item:any){
        let foundTemplate = this.allProjects.find((project:any) => {
            if (project.activities && project.activities !== null && project.activities.length) {
                return project.activities.some((activity: any) => {
                    if (activity && activity.budget !== null) {
                        return String(activity.budget.budgetTemplateId) == String(item.id) 
                    }
                    return null
                })
            }
            return null;
        })
        if (foundTemplate && foundTemplate !== '' && foundTemplate != null) {
            return true
        }else {
            return false
        }
    }

    checkErrors() {
        this.formErrors = []

        if(this.activeTemplate.templateName.length < 1) {
            this.formErrors.push('Template name is Required')
        }
        if(!this.checkDept) {
            this.formErrors.push('Template Section and Budget LineItems is Required')
        }
    }

    private get getAllTemplates () {
        return this.$store.getters['budgetTemplateModule/getAllTemplates'].sort((a: any, b: any) => {
            const itemA = (a.templateName || '').toString().toLowerCase().trim();
            const itemB = (b.templateName || '').toString().toLowerCase().trim();
            return itemA.localeCompare(itemB, undefined, {
                sensitivity: 'base',
                numeric: true
            });
        });
    }

    private get getAllBudgetLines () {
        let allSelectedBudgetLineItems:Array<any> = []
        this.activeTemplate.sections.forEach((s:any) => {
            s.budgetLineItems.forEach((b:any) => allSelectedBudgetLineItems.push(b.id))
        })
        let allBudgetLines = this.$store.getters['budgetLineModule/getAllBudgetLines'].map((thisBudgetLine:any) => ({value:thisBudgetLine.id,text:thisBudgetLine.lineItem,disabled:allSelectedBudgetLineItems.includes(thisBudgetLine.id)}))
        allBudgetLines.sort((a: any, b: any) => {
            const itemA = (a.text || '').toString().toLowerCase().trim();
            const itemB = (b.text || '').toString().toLowerCase().trim();
            return itemA.localeCompare(itemB, undefined, {
                sensitivity: 'base',
                numeric: true
            });
        });
        return allBudgetLines
    }

    private getDepartmentById(deptId:any) {
        let returnedDept = this.$store.getters['departmentModule/getDepartmentById'](deptId)
        if(returnedDept==null) return {name:""}
        return returnedDept;
    }

    private get getDepartmentOptions() {
        return this.$store.getters['departmentModule/getDepartmentOptions'].sort((a: any, b: any) => {
            const itemA = (a.text || '').toString().toLowerCase().trim();
            const itemB = (b.text || '').toString().toLowerCase().trim();
            return itemA.localeCompare(itemB, undefined, {
                sensitivity: 'base',
                numeric: true
            });
        });
    }

    private editTemplate (e: any) {
        this.showForm = true;
        this.isUpdate = true;
        this.activeTemplate.id = e.id
        this.activeTemplate.templateName = e.templateName;
        this.activeTemplate.departmentId = e.departmentId;
        this.activeTemplate.sections = e.sections
    }

    private AddSection(){
        this.activeTemplate.sections.push({
            sectionName:"",
            budgetLineItems:[]
        })
    }

    private removeSection(sectionIndex:number){
        this.activeTemplate.sections.splice(sectionIndex,1)
    }

    private AddBudgetLine(sectionIndex:number){
        this.activeTemplate.sections[sectionIndex].budgetLineItems.push({
            id:null,
            lineItem:"",

        })
    }

    private removeBudgetLineItem(sectionIndex:number,budgetLineIndex:number){
        this.activeTemplate.sections[sectionIndex].budgetLineItems.splice(budgetLineIndex,1)
        this.checkErrors();
    }

    private searchValue(e: any) {
        this.search = e;
    }

    toggleSelectAll() {
        if (!this.selectAll) {
            this.selectedRows = this.getAllTemplates.map((template: any) => ({id: template.id, name: template.templateName}))
        } else {
            this.selectedRows = []
        }
    }

    private promptDelete(item: any){
        this.activeTemplate = item;
        this.deletePromptProperty = true
    }

    getBudgetTemplatesToDelete () {
        const names = this.selectedRows.map(row => row.name);

        let formattedNames = '';
        if (names.length <= 3) {
            const lastTwoNames = names.splice(-2);
            if (this.selectedRows.length === 2) {
                return formattedNames = `${names.join(', ')} ${lastTwoNames.join(' and ')}`;
            }
            return formattedNames = `${names.join(', ')}, ${lastTwoNames.join(' and ')}`;
        }
        else {
            const firstTwoNames = names.slice(0, 2);
            const remainingCount = names.length - 2;
            return `${firstTwoNames.join(', ')} and ${remainingCount} other${remainingCount > 1 ? 's' : ''} budgeting template${remainingCount > 1 ? 's' : ''}`;
        }
    }

    private doDelete (template: any) {
        const isMultipleDelete = this.selectedRows.length;
        this.activeScreen = 'loading'
        EventBus.$emit('activeScreen', this.activeScreen)
        this.loadingMessage = 'Please wait while we delete this template'
        this.loadingMessage = `Please wait while we delete ${isMultipleDelete ? 'these templates' : 'this template'}`
        this.loadingTitle = 'Deleting...'
        const payload = isMultipleDelete ? this.selectedRows.map(row => row.id) : [this.activeTemplate.id]

        this.$store.dispatch('budgetTemplateModule/deleteBudgetTemplate', payload).then(response => {
            this.activeScreen = 'successNoBack'
            EventBus.$emit('activeScreen', this.activeScreen)
            this.additionalSuccessMessage = 'This template will no longer be available'
            this.successMessage = `${isMultipleDelete ? 'Templates' : this.activeTemplate.templateName} Deleted Successfully`
            this.selectedRows = []
            this.deletePromptProperty = false
        },error => {          
            this.activeScreen = 'error'
            EventBus.$emit('activeScreen', this.activeScreen)
            this.error = error.message
            this.deletePromptProperty = false
        })
    }

    private saveTemplate() {
        this.activeScreen = 'loading'
        EventBus.$emit('activeScreen', this.activeScreen)
        let templateToPersist: any  = {
            id:this.activeTemplate.id,
            templateName:this.activeTemplate.templateName,
            departmentId:parseInt(this.activeTemplate.departmentId), 
            budgetTemplateSections: this.activeTemplate.sections.map((s:any)=> ({id:s.id,sectionName:s.sectionName,budgetLineItemIds:s.budgetLineItems.map((b:any)=>b.id)}))
        }
        // Update existing Budget Template
        if(this.isUpdate){
            this.loadingMessage = 'Please wait while we update this template'
            this.loadingTitle = 'Updating...'
            this.$store.dispatch('budgetTemplateModule/updateBudgetTemplate', templateToPersist).then((response: any) => {
                this.activeScreen = 'successNoBack'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.additionalSuccessMessage = ''
                this.successMessage = 'Budget Template Updated Successfully'
            }).catch((error: any) => {
                this.activeScreen = 'error'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.error = error.response.data.data
            })
        }
        // Create New Budget Template
        else{
            this.loadingMessage = 'Please wait while we create new template'
            this.loadingTitle = 'Saving...'
            this.$store.dispatch('budgetTemplateModule/createNewBudgetTemplate', templateToPersist).then((response: any) => {
                this.activeScreen = 'successNoBack'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.additionalSuccessMessage = ''
                this.successMessage = 'Successfully Created '+ templateToPersist.templateName
            }).catch((error: any) => {
                this.activeScreen = 'error'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.error = error.response.data.data
            })
        }
    }

    private view(data: any) {
        this.activeTemplate = data
        this.moreInfo = true
    }

    private backToTemplates () {
        this.activeView = "templates";
        this.showForm = false;
    }

    private newBudegetTemplate () {
        this.activeView = 'operations';
        this.isUpdate = false;
        this.showForm = true;
        this.activeTemplate.templateName = '';
        this.activeTemplate.departmentId = '';
        this.activeTemplate.sections = [];
        this.$v.$reset()
        this.checkErrors()
    }

    private addBudgetLine(el:any) {
        this.activeTemplate.budgetLineItems.push({
            id: el.id,
            lineItem: el.lineItem,
            numberOfDependentTemplates: el.numberOfDependentTemplates
        })
    }

    private removeBudgetLine(index: number) {
        this.activeTemplate.budgetLineItems.splice(index,1)
    }

    private getNumberOfLines(template:any){
        let totalNumberOfSections = 0
        template.sections.forEach((section:any) => {
            totalNumberOfSections+=section.budgetLineItems.length
        });
        return totalNumberOfSections
    }

    mounted() {
        this.loadingMessage = 'Loading Budget Templates';
        this.loadingTitle = 'Loading...';
        
        this.$store.dispatch("projectModule/getAllProjects")
        if(this.getDepartmentOptions.length<1){
            this.$store.dispatch('departmentModule/getDepartments').then(()=> {
                 if (this.getAllTemplates == 0){
                    this.$store.dispatch('budgetTemplateModule/fetchBudgetTemplates')
                    this.activeScreen = 'main'
                    EventBus.$emit('activeScreen', this.activeScreen)
                 } else {
                    this.activeScreen = 'main'
                    EventBus.$emit('activeScreen', this.activeScreen)
                }
            })
        }else{
            if (this.getAllTemplates == 0){
                this.$store.dispatch('budgetTemplateModule/fetchBudgetTemplates')
            } else {
                this.activeScreen = 'main'
                EventBus.$emit('activeScreen', this.activeScreen)
            }
        }
        

        if(this.getAllBudgetLines.length<1){
            this.$store.dispatch('budgetLineModule/fetchBudgetLines')
        }
    }
}
